import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import Theme from 'react-common/theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { BackdropProvider } from '../../../include/react-components/BackdropProvider';
import ErrorBoundary from '../../../include/react-components/ErrorBoundary';
import { GlobalSpinnerProvider } from '../../../include/react-components/GlobalSpinnerProvider';
import TourSearch from './TourSearch';
export default function TourSearchContainer(props) {
    return (React.createElement(BackdropProvider, null,
        React.createElement(GlobalSpinnerProvider, null,
            React.createElement(ErrorBoundary, null,
                React.createElement(ThemeProvider, { theme: Theme },
                    React.createElement(SnackbarProvider, { maxSnack: 3, anchorOrigin: { vertical: 'top', horizontal: 'right' }, domRoot: document.body, classes: { containerRoot: 'snackbar-root' } },
                        React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
                            React.createElement(Router, null,
                                React.createElement(TourSearch, Object.assign({}, props))))))))));
}
